import styled from 'styled-components';
import appTheme from '../../../../themes/Theme';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';

export const StyledFlexGrid = styled(Grid)`
  && {
    display: flex;
    justify-content: center;
    min-height: 390px;
  }
`;

export const StyledCard = styled(Card)`
  && {
    background-color: ${appTheme.cardBackgroundColor};
    color: ${appTheme.textColor};
    position: relative;
    width: 300px;
  }
`;

export const StyledFlexContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledInfoContainer = styled.div`
  display: flex;
  align-items: center;
  word-break: break-word;
`;

export const StyledButtonContainer = styled(CardActions)`
  && {
    display: flex;
    justify-content: center;
    width: 100%;
    position: absolute;
    bottom: 0;
  }
`;
